import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicCard from "./BasicCard/BasicCard";
import PrimaryCard from "./PrimaryCard/PrimaryCard";

const CardPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox title={"Card"} description={""} />
      <Divider light />
      <BasicCard />
      <PrimaryCard />
    </Paper>
  );
};

export default CardPage;
